import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MdSnackBar } from '@angular/material';

import { TdDialogService, TdLoadingService } from '@covalent/core';

import { StorageService } from '../../services/storage.service';

import 'rxjs/add/operator/toPromise';

@Component({
  selector: 'storage-form',
  providers: [StorageService],
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class StorageFormComponent implements OnInit {

  id: number
  storage: any = {};
  storages: any = [];
  action: string;
  storageReference: string = null;
  
  constructor(private _storageService: StorageService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _snackBarService: MdSnackBar,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService) { }

  goBack(): void {
    this._router.navigate(['/storage']);
  }

  ngOnInit(): void {
    this._route.url.subscribe((url: any) => {
      this.action = (url.length > 1 ? url[1].path : 'add');
    });
    this._route.params.subscribe((params: {storageReference: any}) => {
      this.storageReference = params.storageReference;
      if (this.storageReference) {
        this.load();
      } else {
        this.storages = [];
        this.storage = {};
      }
    });
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('storage.form');
      if (this.storageReference) {
        this.storages = await this._storageService.getParcel(this.storageReference).toPromise();
      }
      if (this.storages) {
        this.storage = this.storages[0];
      } else {
        this.storage = {};
      }
    } catch (error) {
      this._dialogService.openAlert({ message: 'There was an error loading the storage' });
    } finally {
      this._loadingService.resolve('storage.form');
    }
  }

  async save(): Promise<void> {
    try {
      this._loadingService.register('storage.form');
      await this._storageService.updateStorage(this.storage, 'UPDATE_WAREHOUSEITEM').toPromise();
      this._snackBarService.open('Storage Saved', 'Ok');
      this.goBack();
    } catch (error) {
      this._dialogService.openAlert({ message: 'There was an error saving the storage' });
    } finally {
      this._loadingService.resolve('storage.form');
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/storage/form/form.component.ts